import * as toastr from 'toastr/toastr.js'

export { toastr }
